import React, { useState, useEffect } from "react";
import ReactBody from "react-body";
import { useSelector } from "react-redux";
import { HashLink as Link } from "react-router-hash-link";
import Content from "../content/Content";
import ContentMeta from "../content/ContentMeta";
import { BandwidthCalc } from "components/core/BandwidthCalc";
import { Helmet } from "react-helmet-async";
import { db } from "../../firebase";

export const BusinessConnect = (props) => {
  const authUser = useSelector((state) => state.sessionState.authUser);
  const [pageContent, setPageContent] = useState(null);

  useEffect(() => {
    if (!window.location.hash) {
      window.scrollTo(0, 0);
    }
    getContent();
  }, []);

  const getContent = () => {
    db.getPageContent("business-connect").then((content) => {
      setPageContent(content.val());
    });
  };

  return pageContent ? (
    <section id="business-connect">
      <Helmet>
        <title>
          {pageContent.meta && pageContent.meta.title
            ? pageContent.meta.title
            : "Alluvion Business Connect"}
        </title>
        <meta
          name="description"
          content={
            pageContent.meta && pageContent.meta.description
              ? pageContent.meta.description
              : "Alluvion Communications provides fast, smart, reliable networks in the Phoenix, AZ area. Browse all of our Fiber, Data, and Voice services and contact us."
          }
        />
      </Helmet>
      {authUser && (
        <ContentMeta page="business-connect" getContent={getContent} />
      )}
      <div className="business-connect-intro content-intro">
        <Content
          page="business-connect"
          pageContent={pageContent}
          item="header"
          type="content"
        />

        <Link to={`#band-calc`}>
          <button className="btn btn-accent">find my plan</button>
        </Link>
      </div>

      <div className="business-connect-content">
        <div className="content-wrap">
          <div className="content-main" id={`content-0 post-0`}>
            <Content
              page="business-connect"
              pageContent={pageContent}
              item="posts"
              itemIndex={0}
              type="content"
              solo={true}
            />
          </div>
        </div>
      </div>
      <div className="bandwidth-calc-wrap">
        <BandwidthCalc />
        <div className="broadband-facts">
          <h3>Broadband Facts</h3>
          <div className="broadband-facts-grid">
            <img
              src={require("images/broadband/100MBPS_1_Alluvion Broadband Facts.png")}
              alt="Broadband Facts - 100MBPS"
            />
            <img
              src={require("images/broadband/100MBPS_2_Alluvion Broadband Facts.png")}
              alt="Broadband Facts - 100MBPS"
            />
            <img
              src={require("images/broadband/100MBPS_3_Alluvion Broadband Facts.png")}
              alt="Broadband Facts - 100MBPS"
            />
            <img
              src={require("images/broadband/100MBPS_4_Alluvion Broadband Facts.png")}
              alt="Broadband Facts - 100MBPS"
            />
            <img
              src={require("images/broadband/500MBPS_1_Alluvion Broadband Facts.png")}
              alt="Broadband Facts - 500MBPS"
            />
            <img
              src={require("images/broadband/500MBPS_2_Alluvion Broadband Facts.png")}
              alt="Broadband Facts - 500MBPS"
            />
            <img
              src={require("images/broadband/500MBPS_3_Alluvion Broadband Facts.png")}
              alt="Broadband Facts - 500MBPS"
            />
            <img
              src={require("images/broadband/500MBPS_4_Alluvion Broadband Facts.png")}
              alt="Broadband Facts - 500MBPS"
            />
            <img
              src={require("images/broadband/1GB_1_Alluvion Broadband Facts.png")}
              alt="Broadband Facts - 1GB"
            />
            <img
              src={require("images/broadband/1GB_2_Alluvion Broadband Facts.png")}
              alt="Broadband Facts - 1GB"
            />
            <img
              src={require("images/broadband/1GB_3_Alluvion Broadband Facts.png")}
              alt="Broadband Facts - 1GB"
            />
            <img
              src={require("images/broadband/1GB_4_Alluvion Broadband Facts.png")}
              alt="Broadband Facts - 1GB"
            />
          </div>
        </div>
      </div>
      <ReactBody className="business-connect" />
    </section>
  ) : (
    <div className="content-intro">
      <div className="content-loading page-loading" />
    </div>
  );
};

export default BusinessConnect;
